<template>
  <div class="page-scholarship-plan-2019"
       :class="{ 'in-iframe': !inH5Platform }"
  >
    <ym-banner :src="require('@/pages/2019/ScholarshipPlan/assets/img/banner.png')"
               :hint="render.status !== 'onGoing' ? '活动已结束' : ''"
    />
    <div class="info"
         :class="{ 'count-down-info': render.countDown }"
    >
      <count-down class="count-down"
                  :start="render.countDown.startTime"
                  :end="render.countDown.endTime"
                  :block-bg-img="getBlockBgImg"
                  :item-bg-img="getItemBgImg"
                  :item-bottom="50"
                  item-color="#3c4657"
                  @count-down-ended="handleCountDownEnded"
                  v-if="render.countDown"
      />
      新学期来临<br/>
      还在纠结给孩子什么样的成长计划<br/>
      在学校课业之外<br/>
      无论是为提高孩子综合素质<br/>
      还是为未来升学或留学规划<br/>
      国际化的素质实践课程必不可少
    </div>
    <div class="coupon-block">
      <div class="coupon"
           @click="handleCouponClick"
      >
        <div class="coupon-left">·可在购买单门直播课时直接抵扣·</div>
        <div class="coupon-right">
          <div class="title">新学期奖学金</div>
          <div class="action"
               :class="{ 'disabled': user && user.isReceive || render.status !== 'onGoing' }"
               v-ym-report:MARKETING_SCHOLARSHIP_2019_GET_COUPON_CLICK
          >
            <template v-if="render.status !== 'onGoing'">
              已结束
            </template>
            <template v-else>
              {{ user && user.isReceive ? '已领取' : '立即领取' }}
            </template>
          </div>
        </div>
      </div>
      <div class="hint">*欢迎把奖学金计划分享给更多也在寻找兴趣，希望快乐成长的同学们。</div>
    </div>
    <receive-coupon-popup :status="receiveStatus"
                          :show.sync="showReceivePopup"
    />

    <product-list :course="course"
                  v-if="course.length > 0"
    />

    <div class="autumn-course-info">
      <div class="title">更多优惠活动</div>
      <div class="sub-title">七大系列直播课，系统学习更优惠</div>
      <div class="hint">更系统的评估报告，更完善的课程体系</div>
      <a class="link-more"
         :href="render.autumnCourseUrl"
         :target="[ inPC ? '_blank' : '_self' ]"
         v-ym-report:MARKETING_SCHOLARSHIP_2019_MORE_CLICK
      >
        了解系列课
        <svg-icon class="icon"
                  icon="right"
        />
      </a>
    </div>
    <div class="line-block"></div>
    <div class="activity-rule">
      <div class="title">· 活动规则 ·</div>
      <div class="rule-block">
        <div class="rule-title">1.活动时间</div>
        <div class="rule-content">2019年8月28日-9月10日</div>
      </div>
      <div class="rule-block">
        <div class="rule-title">2.奖学金规则</div>
        <div class="rule-content">凡是成功领取到200元奖学金，购买课程时将按照现金数额进行抵扣（有效期至2019年9月20日）:</div>
        <div class="rule-content">① 200元奖学金可用于单门直播课；</div>
        <div class="rule-content gray"><span class="gray">② 系列课已享有300元优惠，无法叠加使用。</span></div>
      </div>
      <div class="rule-block">
        <div class="rule-title">3.报课规则</div>
        <div class="rule-content">从报课成功到首节单门直播课结束，您将有一次无条件退换课机会
          （希望每一个孩子都能在少年商学院四大学院中，找到自己真正的兴趣）。</div>
      </div>
      <div class="rule-block">
        <div class="rule-content">4.活动最终解释权归少年商学院所有。</div>
      </div>
    </div>
    <div class="contact-us"
         v-if="inH5Platform"
    >
      <div class="tel"
           v-ym-report:MARKETING_SCHOLARSHIP_2019_PHONE_CLICK
      >
        <a class="external" href="tel:4008093885">电话咨询</a>
      </div>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'ym-mint-ui';
  import { isWeiXinBrowser, isPC } from '@/utils';
  import { getScholarshipPlanInfo, receiveCoupon } from '@/services/scholarship-plan';
  import YmBanner from '@/components/Banner';
  import CountDown from '@/components/CountDown';
  import ReceiveCouponPopup from '@/pages/2019/ScholarshipPlan/components/ReceiveCouponPopup';
  import ProductList from '@/pages/2019/ScholarshipPlan/components/ProductList';

  export default {
    name: 'ScholarshipPlan2019',
    components: {
      YmBanner,
      CountDown,
      ReceiveCouponPopup,
      ProductList,
    },
    data() {
      return {
        course: [],
        coupon: {
          id: 0,
        },
        render: {
          countDown: null,
          user: null,
          autumnCourseUrl: '',
          status: 'onGoing',
          activityType: '',
        },
        user: null,
        receiveStatus: '',
        showReceivePopup: false,
      };
    },
    computed: {
      /* eslint-disable global-require */
      getBlockBgImg() {
        return require('@/pages/2019/ScholarshipPlan/assets/img/count_down_block_bg.png');
      },
      getItemBgImg() {
        return require('@/pages/2019/ScholarshipPlan/assets/img/count_down_item_bg.png');
      },
      /* eslint-enable global-require */
      showQrCode() {
        return isWeiXinBrowser();
      },
      inH5Platform() {
        return !isPC();
      },
      inPC() {
        return isPC();
      },
    },
    methods: {
      async fetchData() {
        const data = await getScholarshipPlanInfo();
        this.course = data.course;
        this.render = data.render;
        this.coupon = data.coupon;
        this.user = data.user;
        this.handleLogin();
      },
      handleLogin() {
        if (this.$route.query && this.$route.query.from === 'H5Login') {
          this.handleCouponClick();
        }
      },
      handleCountDownEnded() {
        this.render.countDown = null;
      },
      async handleCouponClick() {
        if (this.render.status !== 'onGoing') {
          Toast('活动已结束');
          return;
        }
        if (!this.user) {
          window.location.href = decodeURIComponent(this.render.h5LoginUrl);
          return;
        }
        if (this.user.isReceive) {
          this.receiveStatus = 'hasReceived';
          this.showReceivePopup = true;
          return;
        }
        await receiveCoupon(this.coupon.id, this.render.activityType);
        this.user.isReceive = true;
        this.receiveStatus = 'receiveSuccess';
        this.showReceivePopup = true;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>


<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-scholarship-plan-2019 {
    padding-bottom: 100px;
    box-sizing: border-box;
    width: 100%;
    background: #ffe0c7;
    img {
      display: block;
      width: 100%;
    }
    &.in-iframe {
      padding: 0;
    }
  }

  .info {
    width: 100%;
    height: 380px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: @color-white;
    line-height: 46px;
    background: url('~@/pages/2019/ScholarshipPlan/assets/img/header_bg.png') no-repeat;
    background-size: 100% 380px;
    font-size: 26px;
    text-shadow: 0 4px 4px rgba(255,94,65,0.5);
    &.count-down-info {
      height: 578px;
      padding-top: @size-medium;
      flex-direction: column;
      justify-content: flex-start;
      background: url('~@/pages/2019/ScholarshipPlan/assets/img/high_header_bg.png') no-repeat;
      background-size: 100% 578px;
    }
    /deep/ .count-down {
      text-shadow: none;
      .text {
        color: @color-white;
      }
    }
  }

  .coupon-block {
    padding-top: 4px;
    padding-bottom: @size-extra-medium;

    .coupon {
      position: relative;
      width: 100%;
      height: 288px;
      background: url('~@/pages/2019/ScholarshipPlan/assets/img/coupon.png') no-repeat;
      background-size: contain;
    }
    .coupon-left {
      position: absolute;
      left: 80px;
      bottom: 70px;
      font-size: 22px;
      color: #ffece7;
    }
    .coupon-right {
      position: absolute;
      right: 44px;
      top: 0;
      width: 264px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: @color-white;
      .title {
        font-weight: @font-weight-bold;
        font-size: @font-size-large;
        line-height: 1;
      }
      .action {
        margin-top: @size-small;
        width: 206px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(to bottom, rgba(255,227,164,1), rgba(255,205,98,1));
        box-shadow: 0 6px 8px 0 rgba(234, 88, 72, 60%);
        border-radius: 30px;
        font-size: @font-size-large;
        color: #3c4657;
        &.disabled {
          background: linear-gradient(to bottom, rgba(245,246,247,1), rgba(221,221,221,1));
          color: @color-text-light;
        }
      }
    }
    .hint {
      text-align: center;
      font-size: 22px;
      line-height: 1;
      color: #bd8367;
    }
  }

  .autumn-course-info {
    margin: 70px auto 60px;
    padding: @size-medium 0;
    width: 690px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: @color-white;
    box-shadow: 0 12px 26px 1px rgba(255,210,173,0.5);
    border-radius: 30px;
    font-size: @font-size-large;
    .title {
      position: relative;
      line-height: 1;
      color: #c45727;
      &:before {
        position: absolute;
        top: calc(50% - 4px);
        left: -68px;
        content: '';
        width: 48px;
        height: 8px;
        background: url('~@/pages/2019/ScholarshipPlan/assets/img/dot.png') no-repeat;
        background-size: contain;
      }
      &:after {
        position: absolute;
        top: calc(50% - 4px);
        right: -68px;
        content: '';
        width: 48px;
        height: 8px;
        background: url('~@/pages/2019/ScholarshipPlan/assets/img/dot.png') no-repeat;
        background-size: contain;
        transform: rotate(180deg);
      }
    }
    .sub-title {
      margin-top: @size-base;
      margin-bottom: 18px;
      font-weight: @font-weight-bold;
      color: #3C4657;
    }
    .hint {
      height: 50px;
      display: flex;
      align-items: center;
      margin-bottom: @size-base;
      padding: 0 16px;
      font-size: @font-size-base;
      color: #cc8744;
      background: #fff5dd;
      letter-spacing: 1px;
    }
    .link-more {
      padding: 0 @size-base;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 426px;
      height: 80px;
      box-sizing: border-box;
      font-size: 32px;
      color: @color-white;
      background: linear-gradient(to bottom, rgba(255,142,81,1), rgba(255,99,99,1));
      border-radius:40px;
      position: relative;
      .icon {
        position: absolute;
        right: @size-base;
        top: calc(50% - 16px);
      }
    }
  }

  .line-block {
    width: 100%;
    height: @size-small;
    content: '';
    background: #eee;
  }

  .activity-rule {
    padding: @size-medium;
    background: @color-white;
    .title {
      color: @color-text-light;
      font-size: 32px;
      font-weight: @font-weight-bold;
      text-align: center;
    }
    .rule-block {
      margin-top: @size-small;
      font-size: @font-size-small;
      color: @color-text-light;
      .rule-title {
        margin-bottom: @size-small / 2;
        font-weight: @font-weight-bold;
        line-height: 1;
      }
      .rule-content {
        line-height: 1.6;
        position: relative;
        &.gray {
          margin-bottom: @size-medium * 2;
        }
        .gray {
          position: absolute;
          top: 0;
          left: -10px;
          padding-left: 10px;
          background: @color-gray-lighter;
          border-radius: 5px;
        }
      }
    }
  }

  .contact-us {
    position: fixed;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 110px;
    line-height: 110px;
    font-size: 28px;
    background: linear-gradient(to bottom, rgba(255,140,113,1), rgba(255,108,98,1));
    color: @color-white;
    display: flex;
    text-align: center;
    a {
      color: @color-white;
      width: 100%;
      height: 110px;
      display: block;
    }
    .tel {
      flex: 1;
      position: relative;
      &:after {
        position: absolute;
        right: 0;
        top: 15px;
        width: 1px;
        height: 80px;
        content: '';
        background-color: fade(@color-white, 50%);
      }
    }
    .qr-code {
      flex: 1;
    }
  }
</style>
